import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Form, FormGroup, Label, Input } from 'reactstrap'
import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { withTranslation } from 'react-i18next'
import { getUor } from 'reducers'

import Select from 'components/common/Select'

import { fetchFilters, addContracts, removeContracts, emptyAllSelection } from 'actions/contractSelection'
import { setFilters } from 'store/searchFilters'
import { isAdmin, isQualityUser } from 'selectors/user'

class SearchFilters extends Component {
  UNSAFE_componentWillMount() {
    this.props.fetchFilters(this.props.uor)
  }

  toggleValueOfType = (type, value, shouldAdd) => () => {
    let filtered
    if (shouldAdd) {
      filtered = [...this.props.searchFilters[type]]
      filtered.push(value)
    } else {
      filtered = this.props.searchFilters[type].filter((f) => f !== value)
    }
    const newFilter = { ...this.props.searchFilters }
    newFilter[type] = filtered
    this.props.setFilters(newFilter)
  }

  changeProviders = (e) => {
    this.props.setFilters({
      ...this.props.searchFilters,
      providers: e === null ? [] : e.map((i) => i.value),
    })
  }

  changeCountries = (e) => {
    this.props.setFilters({
      ...this.props.searchFilters,
      countries: e === null ? [] : e.map((i) => i.value),
    })
  }

  changeBusinessUnit = (e) => {
    this.props.setFilters({
      ...this.props.searchFilters,
      businessUnit: e === null ? [] : e.map((i) => i.label),
    })
  }

  changeStartYear = (e) => {
    const value = e ? e.value : null
    this.props.setFilters({ ...this.props.searchFilters, startYear: value })
  }

  changeEndYear = (e) => {
    const value = e ? e.value : null
    this.props.setFilters({ ...this.props.searchFilters, endYear: value })
  }

  changeKAM = (e) => {
    this.props.setFilters({
      ...this.props.searchFilters,
      kamUsers: e ? e.value : null, 
    })
  }

  toggleContracts = (counterIds, shouldAdd) => () => {
      this.props.emptyContracts()
      this.props.addContracts(counterIds)
  }

  render() {
    const currentYear = new Date().getFullYear()
    const availableYears = []
    for (let i = currentYear - 5; i < currentYear + 5; i++) {
      availableYears.push({ value: i, label: i })
    }

    return (
      <Form>
        <Row className="filter-section">
          <Col>
            <Row>
              <Col>
                <Label className="filter-title">
                  {this.props.t('sidebar.searchFilters.energyFilter')}
                </Label>
              </Col>
              {this.props.canSeeKam && (
                <Col>
                  <Label className="filter-title">
                    {this.props.t('sidebar.searchFilters.kam')}
                  </Label>
                </Col>
              )}
            </Row>
            <Row className="align-items-center">
              <Col xs="3">
                <Label
                  className={`form-check-label mb-0${
                    this.props.searchFilters.energyType.includes(1) ? ' checked' : ''
                  }`}
                >
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    onChange={this.toggleValueOfType(
                      'energyType',
                      1,
                      !this.props.searchFilters.energyType.includes(1),
                    )}
                  />
                  {this.props.t('sidebar.searchFilters.gaz')}
                </Label>
              </Col>
              <Col xs="3">
                <Label
                  className={`form-check-label mb-0${
                    this.props.searchFilters.energyType.includes(2) ? ' checked' : ''
                  }`}
                >
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    onChange={this.toggleValueOfType(
                      'energyType',
                      2,
                      !this.props.searchFilters.energyType.includes(2),
                    )}
                  />
                  {this.props.t('sidebar.searchFilters.electricity')}
                </Label>
              </Col>
              {this.props.canSeeKam && (
                <Col xs="6">
                  <FormGroup className="mb-0">
                    <Select
                      value={this.props.kamForSelect?.find((option) =>
                        option.value === this.props.searchFilters.kamUsers
                      ) || null}  
                    placeholder={this.props.t('sidebar.searchFilters.providerKam')}
                    options={this.props.kamForSelect}
                    id="valueKam"
                    onChange={this.changeKAM}
                    isClearable={false} 
                    width="90%"
                    isLoading={!this.props.kamForSelect || this.props.kamForSelect.length === 0}
                    bordered
                  />
                </FormGroup>
              </Col>
              )}
            </Row>
          </Col>
        </Row>

        <Row className="filter-section">
          <Col xs="8">
            <Row>
              <Col>
                <Label className="filter-title" for="searchBU">
                  {this.props.t('sidebar.searchFilters.businessUnit')}
                </Label>
              </Col>
            </Row>
            <Row>
              <Col>
                <Select
                    isMulti
                    value={this.props.businessUnitsForSelect?.filter((option) =>
                      this.props.searchFilters.businessUnit?.includes(option.label),
                    )}
                    placeholder={this.props.t('sidebar.searchFilters.buFilter')}
                    options={this.props.businessUnitsForSelect}
                    id="valueBusinessUnits"
                    onChange={this.changeBusinessUnit}
                    isClearable={false}
                    width="100%"
                    bordered
                  />
                </Col>
            </Row>
          </Col>
        </Row>

        <Row className="filter-section">
          <Col>
            <Row>
              <Col>
                <Label className="filter-title">
                  {this.props.t('sidebar.searchFilters.timeframe')}
                </Label>
              </Col>
            </Row>
            <Row className="date-range">
              <Col className="date-range-wrapper">
                <div className="date-range-global">
                  <FormGroup>
                    <Select
                      value={availableYears.find(
                        (option) => option.value === this.props.searchFilters.startYear,
                      )}
                      options={availableYears}
                      onChange={this.changeStartYear}
                      width={100}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Select
                      value={availableYears.find(
                        (option) => option.value === this.props.searchFilters.endYear,
                      )}
                      options={availableYears}
                      onChange={this.changeEndYear}
                      width={100}
                    />
                  </FormGroup>
                </div>
              </Col>
            </Row>

          </Col>
        </Row>

        <Row className="contract-section">
          <Col>
            <ul className="form-radio-list">
              {this.props.countries.map((c) =>
                this.props.contractsByCountryCode[c.code] ? (
                  <li key={c.code}>
                    <Label>
                      {c.libelle}
                    </Label>
                    <ul>
                      {this.props.contractsByCountryCode[c.code].map((ctr) => {
                        const checked = this.props.selectedContracts.includes(ctr.id)
                        return (
                          <li key={ctr.id}>
                            {/* <Label className={`form-check-label${checked ? ' checked' : ''}`}> */}
                              <Input
                                type="radio"
                                onChange={this.toggleContracts([ctr.id], !checked)}
                                checked={checked}
                              />
                              <Label>
                              <i
                                className={`${
                                  ctr.CtrNrjId === 2 ? 'icon-elec' : 'icon-gaz'
                                } left-pad`}
                              ></i>
                              {ctr.FormattedName}
                            </Label>
                          </li>
                        )
                      })}
                    </ul>
                  </li>
                ) : null
              )}
            </ul>
          </Col>
        </Row>
      </Form>
    )
  }
}

SearchFilters.propTypes = {
  contracts: PropTypes.array.isRequired,
  countries: PropTypes.array.isRequired,
  countriesForSelect: PropTypes.array.isRequired,
  providersForSelect: PropTypes.array.isRequired,
  fetchFilters: PropTypes.func.isRequired,
  addContracts: PropTypes.func.isRequired,
  removeContracts: PropTypes.func.isRequired,
  emptyContracts: PropTypes.func.isRequired,
  uor: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => ({
    countries: state.countries,
    providers: state.providers,
    organisations: state.organisations,
    contracts: state.contracts.contractList,
    selectedContracts: state.contracts.contractSelection,
    searchFilters: state.searchFilters,
    uor: getUor(state),
    kamUsers: state.kamUsers || [], 
    canSeeKam: isAdmin(state) || isQualityUser(state),
})

const mapDispatchToProps = (dispatch) => ({
  fetchFilters: (uor) => {
    dispatch(fetchFilters(uor))
  },
  addContracts: (contracts) => {
    dispatch(addContracts(contracts))
  },
  removeContracts: (contracts) => {
    dispatch(removeContracts(contracts))
  },
  setFilters: (filter) => {
    dispatch(setFilters(filter))
  },
  emptyContracts: () => {
    dispatch(emptyAllSelection())
  }
})

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({ countries, providers, organisations, contracts, selectedContracts, searchFilters, kamUsers, t }) => ({
    countriesForSelect: countries.map((c) => ({
      value: c.id,
      label: c.libelle,
    })),
    providersForSelect: providers.map((c) => ({
      value: c.id,
      label: c.libelle,
    })),
    businessUnitsForSelect: organisations?.UorEnfants?.map((c) => ({
      value: c.id,
      label: c.UorNom,
    })),
    kamForSelect: [
    { value: null, label: t('sidebar.panel.unselect') }, 
    ...(kamUsers || []).map((c) => ({ 
      value: c.Id,
      label: `${c.Nom} ${c.Prenom}`,
    }))
  ],
    // Return a map of by country code
    contractsByCountryCode: contracts.reduce((rv, x) => {
      if (
        searchFilters.energyType.includes(x.CtrNrjId) &&
        (searchFilters.providers?.length === 0 ||
          searchFilters.providers.includes(x.CtrIdFournisseur)) &&
        (searchFilters.countries?.length === 0 || searchFilters.countries.includes(x.CtrIdPays)) &&
        (!searchFilters.businessUnit || searchFilters.businessUnit?.length === 0 ||
          searchFilters.businessUnit?.includes(x.BusinessUnitName)) &&
        (!searchFilters.startYear || x.CtrDateFin.split('/')[2] >= searchFilters.startYear) &&
        (!searchFilters.endYear || x.CtrDateDebut.split('/')[2] <= searchFilters.endYear) &&
        (!searchFilters.kamUsers || searchFilters.kamUsers === x.KamUserId)
      ) {
        (rv[x['CtrCodePays']] = rv[x['CtrCodePays']] || []).push(x)
      }
      return rv
    }, {}),
    // Status of a country. 0 for no contract selected, 1 for some, 2 for all
    countryStatus: contracts.reduce((rv, x) => {
      let newValue = 1
      switch (rv[x['CtrCodePays']]) {
        case undefined:
          newValue = selectedContracts.includes(x.id) ? 2 : 0
          break
        case 0:
          newValue = selectedContracts.includes(x.id) ? 1 : 0
          break
        case 2:
          newValue = selectedContracts.includes(x.id) ? 2 : 1
          break
        default:
          break
      }
      rv[x['CtrCodePays']] = newValue
      return rv
    }, {}),
  })),
)(SearchFilters)
